// extracted by mini-css-extract-plugin
export default {"button":"CommonStyles_button__MMOE1","textarea":"CommonStyles_textarea__Etlwq","notFoundPage":"CommonStyles_notFoundPage__W2NMa"};